import { render, staticRenderFns } from "./InviteFriendsEmail.vue?vue&type=template&id=29aab2a9&"
import script from "./InviteFriendsEmail.vue?vue&type=script&lang=js&"
export * from "./InviteFriendsEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports